import { Link } from 'react-router-dom';
import {
  REJOINDRE_AGRICULTEUR,
  REJOINDRE_DISTRIBUTEUR,
} from '@config/assets';
import styles from './Rejoindre.module.css';

export default function Rejoindre() {
  return (
    <>
      {/* ── 1. Page Hero ──────────────────────────── */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>
            Rejoindre le réseau de Bohío Kiskeya
          </h1>
          <p className={styles.heroSubtitle}>
            Construire ensemble une agriculture durable.
          </p>
          <div className={styles.heroBody}>
            <p>
              Bohío Kiskeya rassemble les acteurs qui font vivre
              l&rsquo;agriculture haïtienne&nbsp;: celles et ceux qui cultivent
              la terre, et celles et ceux qui mettent les produits à disposition
              des consommateurs.
            </p>
            <p>
              Que vous soyez agriculteur ou distributeur / commerçant, vous
              pouvez rejoindre un réseau structuré, né du Bas Plateau et tourné
              vers des marchés durables.
            </p>
          </div>
        </div>
      </section>

      {/* ── 2. Vous êtes agriculteur ──────────────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Vous êtes agriculteur</h2>

          <div className={styles.sectionLayout}>
            <div className={styles.sectionText}>
              <p className={styles.sectionSubheading}>
                Rejoindre un réseau qui valorise vos récoltes
              </p>

              <div className={styles.sectionBody}>
                <p>
                  Bohío Kiskeya s&rsquo;adresse aux agriculteurs qui souhaitent
                  mieux organiser leurs récoltes et accéder plus facilement aux
                  marchés urbains.
                </p>
                <p>En rejoignant le réseau, vous&nbsp;:</p>
                <ul className={styles.list}>
                  <li>
                    bénéficiez d&rsquo;un regroupement des volumes avec
                    d&rsquo;autres producteurs
                  </li>
                  <li>
                    êtes accompagnés dans l&rsquo;organisation des livraisons et
                    du transport
                  </li>
                  <li>
                    intégrez une charte qualité commune, pour mieux valoriser vos
                    produits auprès des distributeurs
                  </li>
                  <li>
                    contribuez à une initiative engagée pour la souveraineté
                    alimentaire du pays.
                  </li>
                </ul>

                <p className={styles.engagementTitle}>Vos engagements</p>
                <ul className={styles.list}>
                  <li>respecter la charte qualité Bohío Kiskeya</li>
                  <li>informer le réseau de vos volumes disponibles</li>
                  <li>
                    participer aux temps d&rsquo;échange et de coordination
                    quand c&rsquo;est possible.
                  </li>
                </ul>

                <p className={styles.callout}>
                  Remplissez le formulaire ou contactez-nous, nous vous
                  rappellerons pour échanger sur votre situation et vos cultures.
                </p>
              </div>

              <Link to="/contact" className={styles.btnBlack}>
                Devenir producteur membre
              </Link>
            </div>

            <div className={styles.sectionImageWrap}>
              <img
                src={REJOINDRE_AGRICULTEUR}
                alt="Agricultrice dans un champ de légumes"
                className={styles.sectionImage}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── 3. Vous êtes distributeur ou commerçant ─ */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>
            Vous êtes distributeur ou commerçant
          </h2>

          <div className={styles.sectionLayout}>
            <div className={styles.sectionText}>
              <p className={styles.sectionSubheading}>
                Accéder à une production locale organisée et fiable
              </p>

              <div className={styles.sectionBody}>
                <p>
                  Bohío Kiskeya facilite la mise en relation entre producteurs du
                  Bas Plateau et points de vente urbains.
                </p>
                <p>En devenant partenaire distributeur, vous&nbsp;:</p>
                <ul className={styles.list}>
                  <li>
                    accédez à des produits issus de l&rsquo;agriculture locale
                    (pistaches, légumes, fruits, etc.)
                  </li>
                  <li>
                    bénéficiez d&rsquo;un interlocuteur unique pour le
                    regroupement des récoltes et l&rsquo;organisation logistique
                  </li>
                  <li>
                    disposez d&rsquo;une visibilité claire sur l&rsquo;origine
                    des produits
                  </li>
                  <li>
                    participez à la structuration d&rsquo;une filière agricole
                    durable en Haïti.
                  </li>
                </ul>

                <p className={styles.engagementTitle}>Vos engagements</p>
                <ul className={styles.list}>
                  <li>
                    planifier au mieux vos besoins (volumes, fréquences, types de
                    produits)
                  </li>
                  <li>
                    respecter les conditions de collaboration définies ensemble
                  </li>
                  <li>
                    mettre en avant, lorsque c&rsquo;est possible,
                    l&rsquo;origine des produits Bohío Kiskeya dans vos points de
                    vente.
                  </li>
                </ul>

                <p className={styles.callout}>
                  Dites-nous qui vous êtes, vos besoins et votre
                  localisation&nbsp;: nous reviendrons vers vous pour étudier les
                  possibilités de collaboration.
                </p>
              </div>

              <Link to="/contact" className={styles.btnBlack}>
                Devenir point de vente partenaire
              </Link>
            </div>

            <div className={styles.sectionImageWrap}>
              <img
                src={REJOINDRE_DISTRIBUTEUR}
                alt="Marché local avec produits frais"
                className={styles.sectionImage}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── 4. Catch-all CTA ──────────────────────── */}
      <section className={styles.catchAll}>
        <div className={styles.container}>
          <div className={styles.catchAllBody}>
            <p>
              Vous n&rsquo;êtes pas certain·e de rentrer dans l&rsquo;une de ces
              catégories&nbsp;?
            </p>
            <p>
              Écrivez-nous&nbsp;: nous étudierons ensemble la meilleure façon de
              collaborer.
            </p>
          </div>
          <Link to="/contact" className={styles.btnBlack}>
            Nous contacter
          </Link>
        </div>
      </section>
    </>
  );
}
